
































































import CategoryResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MeditationService/CategoryResponse";
import { Vue, Component, Inject } from "vue-property-decorator";
import { REWARD_CREATE, REWARD_EDIT } from "@/route-names";
import EventBus from "@models/eventBus";
import { RewardFilterModel } from "@models/reward";
import RewardTriggerResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/Reward/RewardTriggerResponse";
import { DragLiModel } from "@components/ui/models";
import SearchRewardRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/Reward/SearchRewardRequest";
import TranslationItemModel from "@models/translationItemModel";
import ChangeSortIndexRequest from "@/api/dataSource/api/Spirit/Common/Helpers/Models/ChangeSortIndexRequest";
import SortIndexRequest from "@/api/dataSource/api/Spirit/Common/Helpers/Models/SortIndexRequest";

@Component
export default class PageRewardsComponent extends Vue {
  @Inject("eventBus") eventBus: EventBus;
  filter: RewardFilterModel = new RewardFilterModel();
  columnNames = [
    "#",
    "Значок",
    "Название",
    "Кол-во",
    "Тип",
    "Дата создания",
    "",
    "",
  ];
  createRouteName = REWARD_CREATE;
  editRouteName = REWARD_EDIT;
  noTrigger: RewardTriggerResponse = new RewardTriggerResponse({
    Trigger: null,
    Name: "Выберите тип",
  });

  getDataFunc = this.$api.RewardService.getListAsync.bind(
    this.$api.RewardService
  );

  removeFunc = this.$api.RewardService.deleteRewardAsync.bind(
    this.$api.RewardService
  );

  async created() {}

  async startDelete(item: CategoryResponse) {
    this.eventBus.deleteEntity.trigger({ id: item.Id });
  }

  /**
   * * Получить список для изменения порядка
   */
  async getList() {
    let self = this;
    return new Promise<Array<DragLiModel>>(async (resolve) => {
      await self.$api.RewardService.getListAsync(
        new SearchRewardRequest()
      ).then((response) => {
        if (response.Items) {
          return resolve(
            response.Items.map(
              (x, index) =>
                new DragLiModel({
                  Id: x.Id,
                  SortIndex: index + 1,
                  Image: x.Icon,
                  Translate: x.Translations.map(
                    (t) =>
                      new TranslationItemModel({
                        langCode: t.LangCode,
                        name: t.Name,
                      })
                  ),
                })
            )
          );
        } else {
          return resolve(null);
        }
      });
    });
  }

  /**
   * * Изменить порядковый индекс
   * @param items Список с измененными индексами
   */
  async changeSortIndex(items: Array<DragLiModel>) {
    let self = this;
    return new Promise<boolean>(async (resolve) => {
      await self.$api.RewardService.changeSortIndexAsync(
        new ChangeSortIndexRequest({
          SortIndices: items.map(
            (x) =>
              new SortIndexRequest({
                Id: Number(x.Id),
                SortIndex: x.SortIndex,
              })
          ),
        })
      ).then((result) => {
        if (result) {
          this.$notification.success("Порядок успешно изменен.");
        }
        return resolve(true);
      });
    });
  }
}
